export function createMessage(type, path, message, payload) {
    return {
        type, // success | info | error | warning
        path,
        message,
        payload
    };
}

export class MessageCenter {
    /// listeners: Map<path, { type, handle }>>
    listeners = new Map();

    create(type, path, message, payload) {
        return createMessage(type, path, message, payload);
    }

    post(pathOrMessageObj) {
        if (typeof pathOrMessageObj === 'string') {
            this._triggerAction(createMessage('info', pathOrMessageObj));
        } else {
            /// pathOrMessageObj is message obj
            this._triggerAction(pathOrMessageObj);
        }
    }

    postSuccess(message, path = '/') {
        this._triggerAction({ type: 'success', path, message });
    }

    postInfo(message, path = '/') {
        this._triggerAction({ type: 'info', path, message });
    }

    postError(message, path = '/') {
        this._triggerAction({ type: 'error', path, message });
    }

    postWarning(message, path = '/') {
        this._triggerAction({ type: 'warning', path, message });
    }

    observe(path, type) {
        const _by = {
            by: handle => {
                const actions = this.listeners.get(path) || [];
                actions.push({ type, handle });
                this.listeners.set(path, actions);

                return _by;
            }
        };
        return _by;
    }

    _triggerAction({ type, path, message, payload }) {
        const actions = this.listeners.get(path);
        // console.log('trig ->', 'type:', type, 'path:', path, 'message:', message, 'payload:', payload);
        if (actions) {
            for (const action of actions) {
                if (action.type === type) {
                    action.handle(message, payload);
                }
            }
        }
    }
}
